/** Empty string = same origin (Vite dev server) + `server.proxy` → local microservices. */
const API_BASE_URI = import.meta.env.VITE_BASE_URI ?? "";
export default API_BASE_URI;
// Maps need no key here: Google Maps is served through the backend
// (/api/property/geo), which holds the key. See common/utils/geoApi.js.
export const GOOGLE_RECAPTCHA_API = import.meta.env.VITE_GOOGLE_RECAPTCHA_URI
export const VITE_GOOGLE_TRANSLATOR_API = import.meta.env.VITE_GOOGLE_TRANSLATOR_URI
export const NEWS_URI = import.meta.env.VITE_NEWS_URI
export const S3_BASE_URI = import.meta.env.VITE_S3_BUCKET_BASE_URI
export const HMAC_SECRET_KEY = import.meta.env.VITE_HMAC_SECRET_KEY

/**
 * Cloudflare R2 `public-images` bucket — static app imagery (logos, icons,
 * property placeholders), served as WebP. Defaulted so a missing env var can't
 * blank out the UI. Sample-report PDFs, testimonial videos and KML layers were
 * not migrated and keep their S3 URLs.
 */
export const PUBLIC_IMAGES_BASE_URI =
  import.meta.env.VITE_PUBLIC_IMAGES_BASE_URI ??
  "https://pub-862ddacb791042a3b324aba5d9a12e44.r2.dev"

export const ADMIN_S3_BASE_URI = import.meta.env.VITE_ADMIN_S3_BUCKET_BASE_URI

/**
 * Cashfree SDK environment ("sandbox" | "production").
 * Explicit VITE_CASHFREE_MODE always wins; otherwise default to "production"
 * for production builds and "sandbox" for dev/preview builds so real customer
 * payments can complete in prod while local/dev stays on sandbox.
 */
export const CASHFREE_MODE =
  import.meta.env.VITE_CASHFREE_MODE ||
  (import.meta.env.PROD ? "production" : "sandbox");